import angular from 'angular';
import masonryComponent from './libs/components/masonryComponent';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { ensure } from 'components/sharpr/ensure/ensure';
import { SourceLogo } from 'components/sharpr/sourceLogo/SourceLogo';
import _ from 'lodash';

angular.module('sh.newsroom.masonry', []).directive('shMasonry', masonryComponent);

export default function NewsroomScreenRunMasonryRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.NewsroomScreenRunMasonry', {
		url: '/newsroom/masonry/:code',
		controllerAs: 'vm',
		controller: NewsroomScreenRunMasonryCtrl,
		templateUrl: '/ng/hub/Newsroom/Screen/Run/Masonry/NewsroomScreenRunMasonryCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Newsroom/Screen/Run/Masonry/NewsroomScreenRunMasonryCtrl.css'),
			$title: () => 'Newsroom :: Cards',
			newsroom: ApiResourcify.public('/newsrooms/screens/run/:code'),
			sourceLogos: ApiResourcify.public('/feeds/logos'),
		},
	});
}

class NewsroomScreenRunMasonryCtrl {
	constructor(newsroom, modal, Api, Pubnub, sourceLogos, ErrorScreen) {
		'ngInject';
		this.newsroom = ensure.object(newsroom);
		this.newsroom.options = ensure.object(this.newsroom.options);
		this.newsroom.options.elements = ensure.object(this.newsroom.options.elements);
		this.posts = ensure.array(newsroom.posts);
		if (this.posts.length < 1) {
			ErrorScreen.show({
				class: 'not-allowed',
				title: 'Not enough content',
				message: 'This newsroom screen needs more posts before it can be displayed.',
				actionText: 'Home',
				actionUrl: '/',
			});
			return;
		}
		this.Api = Api;
		this.timerLabel = 'Insight update in...';
		SourceLogo.splice(sourceLogos, this.posts, 'white');
		Pubnub.awaitReload('newsroom_' + newsroom.code);
		this.colors = _.pluck(this.newsroom.colors, 'bgColor');
		if (this.newsroom.options.elements.fullscreen !== '0') {
			modal
				.fullscreen({
					text: 'Go fullscreen?',
					heading: 'Newsroom Mode',
					timeoutMs: 8000,
				})
				.then(
					() => {},
					() => {}
				);
		}
		if (this.newsroom.options.elements.refresh > 0) {
			setInterval(() => {
				this.Api.get(`/newsrooms/screens/run/${this.newsroom.code}`, null, {
					Authorization: 'Public',
				}).then(newsroom => {
					const newsroomObject = ensure.object(newsroom);
					const updatedPosts = ensure.array(newsroomObject.posts);

					if (updatedPosts.length > 0) {
						this.posts = updatedPosts;
					}
				});
			}, this.newsroom.options.elements.refresh * 1000);
		}
	}
}
